'use strict';

var UserFbcExclusionRulesDirective = function UserFbcExclusionRulesDirective() {
  return {
    restrict: 'E',
    controller: 'UserFbcExclusionRulesController',
    template: require('../templates/user-fbc-exclusion-rules.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
UserFbcExclusionRulesDirective.$inject = [];
module.exports = UserFbcExclusionRulesDirective;